export const addressFields = [
  { id: 'cep', label: 'CEP', type: 'text', mask: 'cep', max_length: 9, required: true },
  { id: 'address', label: 'Logradouro', type: 'text', max_length: 255, required: true },
  { id: 'address_number', label: 'Número', type: 'text', max_length: 30, required: false },
  { id: 'address_complement', label: 'Complemento', type: 'text', max_length: 100, required: false },
  { id: 'neighborhood', label: 'Bairro', type: 'text', max_length: 100, required: true },
  { id: 'city', label: 'Cidade', type: 'text', max_length: 100, required: true },
  { id: 'state', label: 'Estado', type: 'select', required: true, options: ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'] },
];

export function includeAddressFields(fields, index = fields.length) {
  const remaining = fields.filter((_, i) => i !== index);
  const present = new Set(remaining.map(field => field.id));
  const added = addressFields.filter(field => !present.has(field.id)).map(field => ({ ...field }));
  return [...remaining.slice(0, index), ...added, ...remaining.slice(index)];
}
